import { Component, Input } from '@angular/core';

@Component({
	selector: '',
	template: ''
})
export class SnQuillViewComponent {
	@Input() content: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/common/sn-quill-view/sn-quill-view.ts